import {
  AccordionSummary,
  Box,
  Button,
  Chip,
  IconButton,
  Popover,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FormControl from "@mui/material/FormControl";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import Accordion from "@mui/material/Accordion";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccordionDetails from "@mui/material/AccordionDetails";
import FormGroup from "@mui/material/FormGroup";

const TimeOfDay = ({ type, onTimeChange }) => {
  // const [startTime, setStartTime] = useState(dayjs("09:00", "HH:mm"));
  const [startTime, setStartTime] = useState(null);
  // const [endTime, setEndTime] = useState(dayjs("17:00", "HH:mm"));
  const [endTime, setEndTime] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleStartTimeChange = (newTime) => {
    setStartTime(newTime);
  };

  const handleEndTimeChange = (newTime) => {
    setEndTime(newTime);
  };

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const time = searchParams.get("time");
    if (time) {
      const [startTime, endTime] = time.slice(1, -1).split("to");
      setStartTime(dayjs(startTime, "HH:mm"));
      setEndTime(dayjs(endTime, "HH:mm"));
    }
  }, [searchParams]);

  useEffect(() => {
    if (type === "Accordion") {
      onTimeChange(startTime, endTime);
    }
  }, [startTime, endTime]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "time-of-day" : undefined;

  useEffect(() => {
    if (open) {
      document.documentElement.style.overflow = "hidden";
      document.documentElement.style.paddingRight = "17px";
    } else {
      document.documentElement.style.overflow = "";
      document.documentElement.style.paddingRight = "";
    }
  }, [open]);

  const handleTimeClear = () => {
    setStartTime(dayjs("09:00", "HH:mm"));
    setEndTime(dayjs("17:00", "HH:mm"));
  };

  const handleApplyClick = () => {
    if (startTime && endTime) {
      const formattedStartTime = startTime.format("HH:mm");
      const formattedEndTime = endTime.format("HH:mm");

      setSearchParams({
        ...Object.fromEntries(searchParams),
        time: JSON.stringify(formattedStartTime + "to" + formattedEndTime),
      });
    }

    handleClose();
  };

  const formControl = (
    <FormControl component="fieldset" variant="standard">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        {/*<Box sx={{display: 'flex'}}>*/}
        <MobileTimePicker
          label="From"
          value={startTime}
          onChange={handleStartTimeChange}
          slotProps={{ textField: { size: "small" } }}
          sx={{ mb: 1.5 }}
        />
        <MobileTimePicker
          label="To"
          value={endTime}
          onChange={handleEndTimeChange}
          slotProps={{ textField: { size: "small" } }}
        />
        {/*</Box>*/}
      </LocalizationProvider>
    </FormControl>
  );

  if (type === "Accordion") {
    return (
      <Accordion sx={{ backgroundColor: "#f7f7f7" }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="time-of-day-content"
          id="time-of-day-header"
        >
          <Typography>Time of Day</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ textAlign: "center" }}>{formControl}</Box>
        </AccordionDetails>
      </Accordion>
    );
  } else {
    return (
      <>
        <Chip
          label="Time of Day"
          variant="outlined"
          color="white"
          onClick={handleClick}
          sx={{ width: "100%", fontSize: { xs: "0.69rem", sm: "0.8125rem" } }}
        />
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          sx={{ marginTop: "-32px", borderRadius: "25px" }}
          slotProps={{ paper: { sx: { borderRadius: "16px" } } }}
        >
          <Box sx={{ borderRadius: "25px", padding: "0", width: "195px" }}>
            <Stack spacing={2}>
              <Chip
                label="Time of Day"
                variant="outlined"
                color="white"
                // onClick={handleClick}
                sx={{
                  width: "100%",
                  fontSize: { xs: "0.69rem", sm: "0.8125rem" },
                  backgroundColor: "#0B3C65",
                }}
              />
              {/*<Box*/}
              {/*  sx={{*/}
              {/*    display: "flex",*/}
              {/*    justifyContent: "space-between",*/}
              {/*    alignItems: "center",*/}
              {/*  }}*/}
              {/*>*/}
              {/*  <Typography variant="button" display="block">*/}
              {/*    Time of Day*/}
              {/*  </Typography>*/}

              {/*  <IconButton aria-label="clear" onClick={handleClose}>*/}
              {/*    <CloseIcon />*/}
              {/*  </IconButton>*/}
              {/*</Box>*/}
              <Box sx={{ padding: "0 18px 18px 18px" }}>
                <Box>{formControl}</Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "25px",
                  }}
                >
                  <Button size="small" variant="text" onClick={handleTimeClear}>
                    clear
                  </Button>
                  <Button
                    color="yellow"
                    variant="contained"
                    sx={{
                      borderRadius: "25px",
                      marginTop: "2px",
                      fontWeight: 600,
                    }}
                    onClick={handleApplyClick}
                  >
                    Apply
                  </Button>
                </Box>
              </Box>
            </Stack>
          </Box>
        </Popover>
      </>
    );
  }
};

export default TimeOfDay;
